import { useQuery } from '@tanstack/react-query'

import { loyaltyService } from '../services/loyalty.service'

interface UsePosLoyaltyQuoteOptions {
  customerId: number | null
  cartRevision: string | null
  hasCart: boolean
  useLoyalty: boolean
  isDelivery: boolean
}

export function usePosLoyaltyQuote({
  customerId,
  cartRevision,
  hasCart,
  useLoyalty,
  isDelivery,
}: UsePosLoyaltyQuoteOptions) {
  return useQuery({
    queryKey: [
      'pos-loyalty-quote',
      customerId,
      cartRevision,
      isDelivery,
      useLoyalty,
    ],
    queryFn: () => loyaltyService.quote({
      customerId: customerId as number,
      useLoyalty,
      isDelivery,
    }),
    enabled: Boolean(customerId && hasCart),
    staleTime: 0,
    retry: false,
  })
}
